import { type Collaborators } from '../../common/types';

type AccountIds = string[];

export const getCollaboratorsWithJiraAccess = async (
	cloudId: string,
	collaborators: Collaborators,
): Promise<Collaborators> => {
	const accountIds = collaborators.map((c) => c.id);
	const response = await fetch(
		'/gateway/api/growth/cross-join-third-party-nudges/get-permitted-users',
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				cloudId,
				product: 'jira-software',
				accountIds,
			}),
		},
	);

	const returnedAccountIds = (await response.json()) as AccountIds;
	return collaborators.filter((c) => returnedAccountIds.includes(c.id));
};
